// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bob as _bob } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bob chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 60808
 * Chain Name: BOB
 * Default Block Explorer: https://explorer.gobob.xyz
 * Default RPC URL: https://rpc.gobob.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bob } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bob,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bob = createCommon({
	..._bob,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
